import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/blog19/image1 the actors.png";
import image2 from "../../../../assets/images/blog19/image2 US debt burden projection.png";
import image3 from "../../../../assets/images/blog19/image3 macro risk unwind.png";
import image4 from "../../../../assets/images/blog19/image4 weaker dollar volatility cost higher.png";
import image5 from "../../../../assets/images/blog19/image5 Friday protection costs go up.png";
import image6 from "../../../../assets/images/blog19/image6 US PPI fall.png";
import image7 from "../../../../assets/images/blog19/image7 Trump warns Walmart.png";
import image8 from "../../../../assets/images/blog19/image8 SMHSPY fade.png";
import image9 from "../../../../assets/images/blog19/image9 VIX 6w down from top.png";
import image10 from "../../../../assets/images/blog19/image10 Treasury short interest.jpeg";
import image11 from "../../../../assets/images/blog19/image11 spx _ 50dma.png";
import image12 from "../../../../assets/images/blog19/image12 _ of stocks overbought NAS.jpeg";
import image13 from "../../../../assets/images/blog19/image13 S&P patterns re Inauguration day.jpeg";
import image14 from "../../../../assets/images/blog19/image14 Nas narratives.jpeg";
import image15 from "../../../../assets/images/blog19/image15 BOA Bull Bear.png";
import image16 from "../../../../assets/images/blog19/image16 1960s analog.png";
import image17 from "../../../../assets/images/blog19/image17 1966-1970 analog.png";
import image18 from "../../../../assets/images/blog19/image18 GOLD v BTC oddity.png";
import image19 from "../../../../assets/images/blog19/image19 EW 190525.png";
import image20 from "../../../../assets/images/blog19/image20 earnings exp vol this week.png";
import image21 from "../../../../assets/images/blog19/image21 swiss yield curve.jpeg";
import image22 from "../../../../assets/images/blog19/image22 UoM employment woes.jpeg";
import image23 from "../../../../assets/images/blog19/image23 EW 120525.png";
import image24 from "../../../../assets/images/blog19/image24 nas china gap.png";
import image25 from "../../../../assets/images/blog19/image25 ES gap on China.png";
import image26 from "../../../../assets/images/blog19/image26 Trump pharma kill.png";
import image27 from "../../../../assets/images/blog19/image27 Trump tax bill.png";
import image28 from "../../../../assets/images/blog19/image28 nas100 wedge.png";
import image29 from "../../../../assets/images/blog19/image29 NQ wedge.png";
import image30 from "../../../../assets/images/blog19/image30 US yields 4.8_ bet.png";
import image31 from "../../../../assets/images/blog19/image31 ZN sell bet.png";
import image32 from "../../../../assets/images/blog19/image32 US30y threatens 5_ Trump put.png";
import image33 from "../../../../assets/images/blog19/image33 gold into buy zone range top.png";
import image34 from "../../../../assets/images/blog19/image34 Walmrt margin warning.jpeg";
import image35 from "../../../../assets/images/blog19/image35 NQ dojis.png";
import image36 from "../../../../assets/images/blog19/image36 NAS dojis.png";
import image37 from "../../../../assets/images/blog19/image37 May SPX OPtions EXpiry.png";
import image38 from "../../../../assets/images/blog19/image38 EU surplus with US.png";
import image39 from "../../../../assets/images/blog19/image39 EZ trade surplus with US.png";
import image40 from "../../../../assets/images/blog19/image40 UoM employment views.png";
import image41 from "../../../../assets/images/blog19/image41 UoM survey results 160525.png";

const Blog19 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – May 19, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Moody’s Cuts, Bond Market Shifts, and the Liquidity Mirage: Can the Rally Hold?
        </p>
        <p>
          Markets hit a wall as Moody’s strips the U.S. of its final AAA rating, Trump’s tax bill faces internal fire, and semis signal exhaustion. Volatility is creeping back, macro clarity is
          fading, and traders are left navigating a deeply uncertain setup. This week brings a lighter macro calendar, but the aftershocks from last week are just beginning.
        </p>

        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: “Sentiment Led the Rally—Now Data Must Defend It”</p>
              <p>
                The market came into last week high on hope—China de-escalated, Middle East diplomacy stole headlines, and the Trump Put looked alive and well. But behind the optimism, cracks are
                forming.
              </p>
              <p>
                Moody’s downgrade of U.S. credit to <span className="highlightedText">Aa1</span> on Friday was more than symbolic. It confirmed what bond vigilantes have already been pricing in: that
                deficits are spiralling, and Washington is asleep at the wheel. That downgrade landed just as Trump’s blockbuster tax bill hit friction, with conservatives baulking over cost and
                timing.
              </p>
              <p>“Moody’s isn’t a friend of Trump, and the timing is no accident. A mid-debate downgrade is a political blow and a market risk.”</p>
              <p>Meanwhile, markets reversed right after Friday’s options expiry, a classic rug-pull, leaving gaps open and gamma support stripped away.</p>
              <p>Buffett hoarding cash, Burry shorting, Trump spinning—this sums up sentiment.</p>
            </div>
            <div className="relatedImg">
              <img
                src={image1}
                alt="the actor"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image1)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Key Sentiment Signals:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Moody’s joins Fitch and S&P in downgrading U.S. credit</p>
                </li>
                <li className="themesPointer">
                  <p>Trump’s tax bill faces internal GOP resistance</p>
                </li>
                <li className="themesPointer">
                  <p>The volatility bubble popped in the final 15 minutes on Friday</p>
                </li>
                <li className="themesPointer">
                  <p>Burry exits stocks, loads puts—volume spikes at highs</p>
                </li>
                <li className="themesPointer">
                  <p>Treasury short interest surging—were big players front-running the downgrade?</p>
                </li>
                <li className="themesPointer">
                  <p>VIX saw 6 consecutive weeks down—until last week</p>
                </li>
                <li className="themesPointer">
                  <p> Retail continues to pile into 3x/5x ETFs—classic late-cycle pattern</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="imageWrapperCont">
            <div className="relatedImg">
              <img
                src={image10}
                alt="Treasury short interest"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image10)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <div className="relatedImg">
              <img
                src={image9}
                alt="VIX 6w down from top"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image9)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <div className="relatedImg">
              <img
                src={image12}
                alt=" % of stocks overbought NAS"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image12)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <p className="highlightedBoldText">Macro & Policy Watch: Debt, Politics, and the End of Forecast Certainty</p>
              <p className="highlightedText_header">Moody’s Downgrade: America’s Last AAA Falls</p>

              <p>
                Moody’s cited “the decline in fiscal metrics” and the unrelenting rise in U.S. debt and deficits. Their downgrade came with a stable outlook, but the message is clear: the U.S. is not
                immune to debt math.
              </p>
              <p>
                Lawmakers are trying to extend parts of the 2017 tax cuts, costing $3.8 trillion over a decade. Even Trump loyalists blocked the bill Friday, citing cost. The pressure is mounting.
              </p>
              <p>“The downgrade reflects not just policy failure, but structural market concerns. Borrowing costs are heading higher.”</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="US debt burden projection"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt="BOA Bull Bear"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv  ">
              <p className="highlightedText_header">Central Banks Abandon the Forecast Compass</p>

              <p>
                Both the <span className="highlightedText">Fed</span> and the <span className="highlightedText">Bank of England</span> are dropping traditional forecast-based signalling. Powell
                admitted that post-GFC frameworks don’t apply anymore. The BoE’s Andrew Bailey confirmed that baseline projections will now come alongside scenario alternaFtives—an admission that
                economic models are failing under repeated supply shocks.
              </p>
              <p>Bernanke’s policy review is influencing this shift, but the result is less clarity for markets.</p>
              <p>“The Fed is guiding without a map. The BoE just tore up the old one.”</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Dollar Wobble: From Safe Haven to Warning Signal</p>
              <p>The weak dollar, once a sign of risk-on flows, is now being read as capital flight. Treasury auctions are once again being quietly supported by the Fed. That’s QE in all but name.</p>
              <p>“QT may be slowing, and nobody’s admitting it. If that’s true, this rally was liquidity-driven, not fundamentals-based.”</p>
            </div>
            <div className="relatedImg">
              <img
                src={image4}
                alt="Weaker dollar volatility cost higher"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image4)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <p className="highlightedBoldText">Technical & Sentiment Setups: Rally Stretched, Risks Rising</p>
              <p className="highlightedText_header">Semis, SPX, Nasdaq—Signs of Exhaustion</p>
              <p>
                Volume surged last week near the top of the recent rally, especially in <span className="highlightedText">QQQ, SPY</span> and <span className="highlightedText">NDAQ.</span> The{" "}
                <span className="highlightedText">SMH/SPY</span> ratio rolled over. Semis are no longer leading. Nasdaq has printed a wedge top, and SPX has opened gaps with no gamma support below.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt="SMHSPY fade"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt="nas100 wedge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image25}
                    alt="ES gap on China"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image25)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>“High volume at resistance is rarely bullish—especially when hedges are gone and retail is leveraged.”</p>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <p className="highlightedText_header">Leveraged Retail, Bearish Hedge Funds—Classic Pain Setup</p>
              <p>
                Hedge fund positioning remains bearish, but retail is doubling down via <span className="highlightedText">leveraged ETFs.</span> This is exactly what happened before the last blow-off
                tops in 2021 and 2018.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt="% of stocks overbought NAS"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="spx > 50dma"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>“The most dangerous place to be is comfortably long into a leveraged retail rally with no gamma floor.”</p>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <p className="highlightedText_header">Gold & BTC: Ready for a Store-of-Value Rotation?</p>
              <p>
                Gold has bounced from the buy zone mentioned last week. BTC is consolidating after outperforming. The disconnect between the two may resolve, especially if the dollar sees another
                wobble.
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image18}
                alt="GOLD v BTC oddity"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image18)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <p className="highlightedBoldText">Last Week in Review: China Starts It, Moody’s Ends It</p>

          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedText_header">China De-escalates, Retail Cheers, Bond Markets Frown</p>
              <p>
                The week started with optimism as China agreed to de-escalate tariffs, reducing barriers and agreeing to crack down on fentanyl. Trump called it historic. But Friday’s downgrade
                stripped away the sugar-coating.
              </p>
              <p className="highlightedText_header">Key Data Recap: Signs of Cooling</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CPI: </span>
                    Flat headline, but core shelter still rose—airfares, insurance, and used cars fell
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">PPI: </span> Negative surprise—monthly deflation hints at margin stress
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Imports: </span> Ex-fuel imports rose 0.8% MoM—re-stocking or demand?
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Retail Inventories:</span> Still front-loaded—upside risk to Q2 GDP?
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="relatedImg">
            <img
              src={image6}
              alt=""
            />
            <div
              className="zoomBtn"
              onClick={() => handleLargeImg(image6)}
            >
              <button>
                <img
                  src={zoomImg}
                  alt=""
                />
              </button>
            </div>
          </div>
          <p>“Disinflation, not inflation. But cracks are forming in margins, not prices.”</p>
        </div>

        <hr className="divisionLine" />

        <p className="highlightedBoldText">The Week Ahead: Light Calendar, Heavy Implications</p>

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Monday, May 19</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>China's retail sales, industrial production, and fixed investment</p>
                  </li>
                  <li className="themesPointer">
                    <p>Eurozone final CPI</p>
                  </li>
                  <li className="themesPointer">
                    <p>Trump-Putin call + Tax bill signing attempt</p>
                  </li>
                  <li className="themesPointer">
                    <p>FOMC speakers (Williams, Bostic, Logan, Kashkari, Jefferson)</p>
                  </li>
                  <li className="themesPointer">
                    <p>USD auctions: 3m, 6m Bills</p>
                  </li>
                </ul>
                <p>
                  <span className="highlightedText">Earnings: </span>Trip.com, Ryanair, Naturgy Energy
                </p>
              </div>
            </div>
          </div>
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Tuesday, May 20</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>China Loan Prime Rate (expected cut)</p>
                  </li>
                  <li className="themesPointer">
                    <p>RBA Rate Decision (cut expected)</p>
                  </li>
                  <li className="themesPointer">
                    <p>CAD CPI, EZ Consumer Confidence</p>
                  </li>
                  <li className="themesPointer">
                    <p>FOMC Barkin, Bostic, Collins</p>
                  </li>
                </ul>
                <p>
                  <span className="highlightedText">Earnings: </span> Palo Alto, Home Depot, Vodafone, Toll Bros
                </p>
              </div>
            </div>
          </div>
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Wednesday, May 21</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>UK CPI</p>
                  </li>
                  <li className="themesPointer">
                    <p>German 10Y Bund auction</p>
                  </li>
                  <li className="themesPointer">
                    <p>US 20Y Bond auction</p>
                  </li>
                  <li className="themesPointer">
                    <p>JPY & NZ trade balances</p>
                  </li>
                </ul>
                <p>
                  <span className="highlightedText">Earnings:</span> Target, Lowe’s, TJX, Zoom, Baidu, Medtronic
                </p>
              </div>
            </div>
          </div>

          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Thursday, May 22</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>Global Flash PMIs: US, UK, EZ, Japan</p>
                  </li>
                  <li className="themesPointer">
                    <p>US 10Y TIPS auction</p>
                  </li>
                  <li className="themesPointer">
                    <p>US Jobless Claims, Existing Home Sales</p>
                  </li>
                </ul>
                <p>
                  <span className="highlightedText">Earnings:</span> Ross Stores, Intuit, Analogue Devices
                </p>
              </div>
            </div>
          </div>
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Friday, May 23</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>GBP Retail Sales, GfK Consumer Sentiment</p>
                  </li>
                  <li className="themesPointer">
                    <p>EZ Trade Balance</p>
                  </li>
                  <li className="themesPointer">
                    <p>US New Home Sales, Building Permits</p>
                  </li>
                  <li className="themesPointer">
                    <p>CAD Retail Sales</p>
                  </li>
                  <li className="themesPointer">
                    <p>JPY CPI</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Wait for the Fall or the Follow-Through</p>
              <p>
                Markets may be at an inflexion. If bulls can hold the line, the ingredients for a gamma squeeze are there. But without clear data support and amid massive policy uncertainty, any
                bounce could be short-lived.
              </p>
              <p>“This market has gaps below, no hedges, and retail is overleveraged. If you're long, you're betting on political miracles.”</p>
              <p>Here’s what to track:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Watch SPX 5900—break it, and the structure turns bearish</p>
                </li>
                <li className="themesPointer">
                  <p>If bulls defend this week’s gaps, a June gamma squeeze is in play</p>
                </li>
                <li className="themesPointer">
                  <p>BTC and Gold may start moving in sync, especially if dollar weakness accelerates</p>
                </li>
                <li className="themesPointer">
                  <p>TIPS auction on Thursday could shake inflation narratives</p>
                </li>
                <li className="themesPointer">
                  <p>Treasury yields are still climbing—watch bank appetite and foreign demand</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="imageWrapperCont">
            <div className="relatedImg">
              <img
                src={image26}
                alt="Trump pharma kill"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image26)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <div className="relatedImg">
              <img
                src={image27}
                alt="Trump tax bill"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image27)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <div className="relatedImg">
              <img
                src={image39}
                alt="EZ trade surplus with US"
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image39)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/11b59ndQerFEJynv8GKnTG45RkpDXZP4H2IOkfIjjpcw/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog19;
